import { usePanelStore, type PanelView } from "../../state/panel";
import { IntelligenceView } from "./views/Intelligence";
import { SettingsView } from "./views/Settings";
import { TransactionsView } from "./views/Transactions";
import styles from "./Panel.module.css";

const TITLES: Record<PanelView, { glyph: string; label: string; crumb: string }> = {
  intelligence: { glyph: "◈", label: "intelligence", crumb: "portfolio · vamp · retention" },
  transactions: { glyph: "≋", label: "transactions", crumb: "tc40 · ethoca · evidence" },
  settings: { glyph: "◎", label: "settings", crumb: "acquirer · thresholds · portfolio" },
};

export function Panel() {
  const view = usePanelStore((s) => s.view);
  const meta = TITLES[view];

  return (
    <div className={styles.panel}>
      <header className={styles.header}>
        <span className={styles.glyph}>{meta.glyph}</span>
        <span className={styles.title}>{meta.label}</span>
        <span className={styles.crumb}>{meta.crumb}</span>
      </header>
      <div className={styles.body} key={view}>
        {view === "intelligence" && <IntelligenceView />}
        {view === "transactions" && <TransactionsView />}
        {view === "settings" && <SettingsView />}
      </div>
    </div>
  );
}
